import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createSquareNodeTypeIcon,
  getRoundedRectanglePath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createSecurityManagementIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const mainBorder = makeTag('path', {
    d: getRoundedRectanglePath(4, 4, 32, 32, 2),
    fill: 'none',
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 2,
  });
  const magnifier = `${makeTag('path', {
    d: new SvgPathBuilder().moveTo(15.2, 24.8).lineTo(18.8, 21.2).build(),
    fill: 'none',
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 1.6,
    'stroke-linecap': 'round',
  })}${makeTag('circle', {
    cx: 21.2,
    cy: 18.8,
    r: 3.2,
    fill: 'none',
    stroke: ICON_DEFAULT_FOREGROUND_COLOR,
    'stroke-width': 1.6,
  })}`;
  const drawPoint = (cx: number, cy: number) =>
    makeTag('circle', {
      cx,
      cy,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
      r: 1,
    });
  const drawHLine = (x1: number, y: number, x2: number) =>
    makeTag('path', {
      d: new SvgPathBuilder().moveTo(x1, y).hLineTo(x2).build(),
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 2,
      'stroke-linecap': 'round',
    });

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    ${mainBorder}
    ${magnifier}
    ${drawPoint(7.6, 7.6)}
    ${drawPoint(11.2, 7.6)}
    ${drawPoint(7.6, 32.4)}
    ${drawPoint(11.2, 32.4)}
    ${drawHLine(14.8, 7.6, 32.4)}
    ${drawHLine(14.8, 32.4, 32.4)}
    ${drawHLine(4, 11.2, 36)}
    ${drawHLine(4, 28.8, 36)}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const securityManagementIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createSecurityManagementIcon,
);
